class ProductAccordionHandler {
  constructor() {
    this.accordions = document.querySelectorAll('.product__accordion');
    this.mobileBreakpoint = 750;
    this.init();
  }

  init() {    
    const handleResize = this.debounce(this.handleAccordionState.bind(this), 100);
    handleResize();
    window.addEventListener('resize', handleResize);
  }

  isMobileView() {
    return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
  }

  handleAccordionState() {
    const isMobile = this.isMobileView();
    
    console.log('isMobile', isMobile);
    this.accordions.forEach(accordion => {
      accordion.querySelectorAll('.accordion__item').forEach(detail => {
        detail.setAttribute('open', '');
        if (isMobile) {
          if (detail.querySelector('.accordion__title')?.textContent?.trim() !== 'Details') {
            detail.removeAttribute('open');
          }
        }
      });
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new ProductAccordionHandler();
});
